<template>
	<footer id="site-footer" class="in-module" role="contentinfo" itemscope="itemscope" itemtype="http://schema.org/WPFooter">
    <div class="kussion in-module">
      <dl>
        <dt>ตอบทุกข้อสงสัยเกี่ยวกับริสแบนด์</dt>
        <dd>หากคุณมีคำถามเกี่ยวกับการผลิต Wristband โปรดติดต่อเรา<br>ทีมงานที่เชี่ยวชาญพร้อมให้คำแนะนำด้วยความเต็มใจ</dd>
        <dd class="btnarea ghost">
          <a class="ghost" href="tel:0335262673">ติดต่อเราทางโทรศัพท์<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m521.23-480-123 123L440-314.23 605.77-480 440-645.77 398.23-603l123 123Zm-41.16 380q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z"></path></svg></a>
          <a class="ghost" href="/contact#contact">ติดต่อเราช่องทางอื่นๆ<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960"><path d="m521.23-480-123 123L440-314.23 605.77-480 440-645.77 398.23-603l123 123Zm-41.16 380q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z"></path></svg></a>
        </dd>
      </dl>
    </div>
    
    <a href="#app" class="pagetop">▲ pagetop</a>
    <div class="display">
			<div class="company">
				<dl>
					<dt>บริษัทที่ดำเนินงาน : บริษัท คูคาเฟ่ จำกัด</dt>
					<dd>เลขที่ 3 อาคารพร้อมพันธุ์ 3  ห้อง 1113-1114   ชั้น 11<br>ซอยลาดพร้าว 3 แขวงจอมพล เขตจตุจักร กรุงเทพฯ 10900<br>TEL:02-115-2327, 02-115-2328</dd>
					<dd><a href="https://www.oclcom.com/" target="_blank">https://www.oclcom.com/</a></dd>
				</dl>
			</div>
			<nav>
				<ul>
					<li>
            <dl>
                <dt>คู่มือผู้ใช้</dt>
                <dd itemprop="name"><a itemprop="url" href="/advantage">จุดแข็งของเรา</a></dd>
            </dl>
					</li>
					<li>
						<dl>
							<dt>รายการสินค้า</dt>
              <dd itemprop="name"><a itemprop="url" href="/products">เลือกจากสินค้าทั้งหมด</a></dd>
              <dd itemprop="name"><a itemprop="url" href="/purpose">เลือกจากวัตถุประสงค์</a></dd>
              <dd itemprop="name"><a itemprop="url" href="/price">เลือกจากราคา</a></dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt>เกี่ยวกับสินค้า</dt>
							<dd itemprop="name"><a itemprop="url" href="/template">ฟอร์มออกแบบ</a></dd>
              <dd itemprop="name"><a itemprop="url" href="/faq">คำถามที่พบบ่อย</a></dd>
              <dd itemprop="name"><a itemprop="url" href="/voices">รวมผลงาน</a></dd>
              <dd itemprop="name"><a itemprop="url" href="/sample">ขอรับตัวอย่าง</a></dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt>ข้อมูลบริษัท</dt>
							<dd itemprop="name"><a itemprop="url" href="/company">ข้อมูลพื้นฐาน</a></dd>
							<dd itemprop="name"><a itemprop="url" href="/privacy">นโยบายคุ้มครองข้อมูลส่วนบุคคล</a></dd>
							<dd itemprop="name"><a itemprop="url" href="/contact">การสอบถาม</a></dd>
						</dl>
					</li>
					<li>
						<dl>
							<dt>อื่นๆ</dt>
							<dd itemprop="name"><a itemprop="url" href="/blog">บล็อก</a></dd>
							<dd>
                <a @click="openCookie()">
                  Cookie Settings
                </a>
              </dd>
						</dl>
					</li>
				</ul>
			</nav>
		</div>
    <small class="copy">Copyright 2025 OCLCOM Inc. All Rights Reserved.</small>
	</footer>
</template>

<style lang="scss" scoped>
footer{
  background: #2271f5;
  .kussion{
    padding: 6.4rem module.side();
    background: url(/images/common/kussion_bg.webp) fixed no-repeat center center / cover;
    position: relative;
    @media screen and (max-width: module.$tab){
      background: url(/images/common/kussion_bg.webp) scroll no-repeat center center / cover;
    }
    @media screen and (max-width: module.$phone){
      padding: 3.2rem module.side();
    }
    &:before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #000;
      opacity: .64;
    }
    dl{
      color: module.$white;
      position: relative;
      z-index: 2;
      text-align: center;
      dt{
        font-size: 1.96rem;
        font-weight: 700;
        line-height: 1;
        @media screen and (max-width: module.$phone){
          font-size: 1.44rem;
        }
      }
      dd{
        font-size: 1.08rem;
        margin: 1.6rem 0 0;
        &.btnarea{
          @media screen and (max-width: module.$phone){
            grid-template-columns: 1fr;
            gap: 1rem;
            display: grid;
          }
          a{
            margin: 0 1.2rem 0 0;
            @media screen and (max-width: module.$phone){
              margin: 0;
            }
            &:last-of-type{
              margin: 0;
            }
            &.ghost{
              font-size: 1.2rem;
            }
          }
        }
      }
    }
  }
  .pagetop{
    background: #0954d0;
    color: module.$white;
    display: block;
    text-align: center;
    padding: 1rem 0;
    text-transform: uppercase;
  }

  .display{
    min-width: module.$width;
    max-width: 1300px;
    padding: 4.8rem 1.6rem;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 25%;
    color: module.$white;
    @media screen and (max-width: module.$tab){
      min-width: 1px;
      grid-template-columns: 1fr;
      gap: 3.2rem;
      padding: 3.2rem 1.6rem;
    }
    a{
      color: module.$white;
    }
    .company{
      order: 2;
      @media screen and (max-width: module.$tab){
        text-align: center;
      }
      dl{
        margin: 0 0 2rem;
        @media screen and (max-width: module.$tab){
          margin: 0;
        }
        dt{
          font-size: 1.04rem;
          font-weight: 700;
          margin: 0 0 .8rem;
          padding: 0 0 .64rem;
          border-bottom: rgba(module.$white,0.08) 1px solid;
          @media screen and (max-width: module.$tab){
            border-bottom: rgba(module.$white,.12) 1px solid;
          }
        }
        dd{
          a{
            text-decoration: underline;
          }
        }
      }
    }
    nav{
      ul{
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        gap: 2rem;
        @media screen and (max-width: module.$phone){
          display: block;
          border: rgba(module.$normal,.2) 1px solid;
          border-radius: .4rem;
          overflow: hidden;
        }
        li{
          dl{
            dt{
              font-size: 1.12rem;
              font-weight: 700;
              margin: 0 0 .8rem;
              @media screen and (max-width: module.$phone){
                background: rgba(module.$normal,.2);
                padding: .8rem 1.6rem;
                font-size: 1rem;
                margin: 0;
              }
            }
            dd{
              font-size: .76rem;
              margin: .24rem 0 0;
              @media screen and (max-width: module.$phone){
                margin: 0;
                font-size: .96rem;
                border-bottom: rgba(module.$normal,.2) 1px solid;
                &:last-of-type{
                  border: none;
                }
              }
              a{
                position: relative;
                padding: 0 0 0 1.2rem;
                @media screen and (max-width: module.$phone){
                  padding: 1rem 1.6rem;
                  display: block;
                }
                &:hover{
                  text-decoration: underline;
                }
                &:before,
                &:after{
                  content: '';
                  width: 2px;
                  height: .4rem;
                  background: module.$white;
                  position: absolute;
                  top: 45%;
                  left: 0;
                  transform: translateY(-50%) rotate(-45deg);
                  transform-origin: right top;
                  opacity: .24;
                  @media screen and (max-width: module.$phone){
                    left: auto;
                    right: 1.6rem;
                  }
                }
                &:after{
                  transform: rotate(45deg);
                  transform-origin: right bottom;
                }
              }
            }
          }
        }
      }
    }
  }
  .copy{
    font-size: .92rem;
    text-align: center;
    padding: 1.6rem;
    border-top: rgba(module.$white,.12) 1px solid;
    display: block;
    color: module.$white;
  }
}
</style>

<script>
import CookieUtil from './CookieUtil'
import { eventBus } from '../eventBus';

export default {
	data() {
		return {
			currentYear: new Date().getFullYear()
		}
	},
  methods: {
    openCookie(){
      // Cookie削除だけでなく、イベント発火
      CookieUtil.remove('popup');
      eventBus.emit('open-cookie-popup');
    }
  }
}
</script>